module.exports = __webpack_public_path__ + "static/media/cf.9029cb92.svg";